import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  standalone: false
})
export class TooltipComponent implements OnInit {
  @Input() position: 'below' | 'above' | 'left' | 'right' | 'after' | 'before' | 'right' | 'left' = 'above';
  @Input({ required: true }) tooltipText!: string;
  control!: FormControl;

  ngOnInit(): void {
    this.control = new FormControl(this.position);
  }
}
